<template>
	<div>
		<div class="input-wrapper" :class="{'input-wrapper-tooltip': tooltip, 'has-error': error.length > 0}">
			<div class="input-label" :class="icon ? 'input-label-icon' : ''">
				<i :class="['input-icon', 'fa', 'fa-fw', icon]" v-if="icon"></i> {{ label }} {{ required ? "*" : "" }}
			</div>
			<div class="input-switch" :class="{'is-right': val, 'is-left': !val}" @click="changed">
				<div class="input-marker"></div>
			</div>
			<div class="input-error">
				{{ error }}
			</div>
		</div>
		<div v-if="tooltip" class="input-tooltip" v-popover:tooltip.left="tooltip">
			<i class="fas fa-question-circle"></i>
		</div>
	</div>
</template>


<script>
	export default {
		name: "FormCheckbox",
		
		props: {
			icon: {
				type: String,
				require: false,
			},
			label: {
				type: String,
				require: true,
			},
			tooltip: {
				type: String,
				require: false,
			},
			value: {
				type: [Boolean, Number, String],
				require: false,
				default: "",
			},
			required: {
				type: Boolean,
				require: false,
				default: false,
			},
		},

		data: function() {
			return {
				error: "",
			}
		},

		computed: {
			val: function() {
				if (typeof this.value === "boolean")
					return this.value
				else
					return parseInt(this.value);
			}
		},

		methods: {
			changed: function() {
				this.error = "";

				if (this.required !== false) {
					if (this.val) {
						this.error = "* Campo obrigatório.";
					}
				}

				if (typeof this.val === 'boolean')
					this.$emit('input', !this.val);
				else
					this.$emit('input', parseInt(this.val) ? 0 : 1);
			}
		}
	}
</script>


<style scoped>
.input-wrapper {
	position: relative;
	width: 100%;
	height: 90px;
	color: #666;
	display: inline;
	float: left;
	margin-bottom: 10px;
}

.input-wrapper-tooltip {
	width: calc(100% - 20px);
}

.input-label {
	position: absolute;
	width: 100%;
	height: 25px;
	line-height: 30px;
}

.input-label-icon {
	padding-left: 30px;
}

.has-error .input-label {
	color: red;
}

.input-switch {
	position: absolute;
	top: 35px;
	width: 54px;
	height: 30px;
	border-radius: 40px;
	cursor: pointer;
	box-shadow: inset 2px 5px 10px rgba(0,0,0,0.3);
}

.input-switch:hover {
	opacity: 0.8;
}

.input-switch > .input-marker {
	position: absolute;
	width: 26px;
	height: 26px;
	border-radius: 100%;
	top: 2px;
	transition: all 0.1s linear;
}

.input-switch.is-left {
	background: #ddd;
}

.input-switch.is-right {
	background: #555;
}

.input-switch.is-left > .input-marker {
	background: #fff;
	left: 2px;
}

.input-switch.is-left > .input-marker-sm {
	left: 2px;
}

.input-switch.is-right > .input-marker {
	background: #fff;
	left: 26px;
}

.input-switch.is-right > .input-marker-sm {
	left: 20px;
}

.input-icon {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 25px;
	height: 25px;
	line-height: 30px;
	text-align: center;
	color: #666;
}

.has-error .input-icon {
	color: red;
}

.input-error {
	width: 100%;
	position: absolute;
	top: 65px;
	font-size: 12px;
	height: 25px;
	line-height: 35px;
}

.has-error .input-error {
	color: red;
}
</style>